import React, { useEffect, useState } from "react";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import AuthService from "../../../Services/ApiServices/AuthService";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import { Link, useNavigate } from "react-router-dom";

const ForgotPassword = () => {

    const [formData, setFormData] = useState({ emailId: "", otp: "", password: "", confirmPassword: "" });
    const [showPass, setshowPass] = useState(false);
    const [showPass2, setshowPass2] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const [isOtpSent, setIsOtpSent] = useState(false);

    const navigate = useNavigate()
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    
    const handleSpaces = (e) => {
        if (e.key === ' ') {
            e.preventDefault();
        };
    };



    const handleGetOtp = async (type, emailId) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailId) {
            alertErrorMessage('Please Enter Email Address..!!');
            return;
        } if (!emailRegex.test(emailId)) {
            alertErrorMessage('Email is invalid');
            return;
        }
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.getOtp(type, emailId);
            LoaderHelper.loaderStatus(false);
            if (result?.success) {
                alertSuccessMessage(result?.message);
                setIsOtpSent(true);
                setCountdown(60);
            } else {
                alertErrorMessage(result?.message);
                setIsOtpSent(false);
                setCountdown(0);
            };
            
        } catch (error) {
            LoaderHelper.loaderStatus(false);
            alertErrorMessage(error);
        }
    };

    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{5,}$/;

        if (!passwordRegex.test(password)) {
            console.error("Invalid password format");
            alertErrorMessage("Password must include at least one letter, one number, one special character, and be at least 5 characters long.");
            return false;
        }
        return true;
    };


    const handleforgotPassword = async (emailId, otp, password, confirmPassword) => {
        if (!emailId || !otp || !password || !confirmPassword) {
            alertErrorMessage('All Fields are required.');
            return;
        } if (!validatePassword(password)) {
            alertErrorMessage("Password must include at least one letter, one number, one special character, and be at least 5 characters long.");
            return;
        }
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.forgotPassword(emailId, otp, password, confirmPassword);
            LoaderHelper.loaderStatus(false);
            if (result?.success) {
                alertSuccessMessage(result?.message);
                navigate("/")
            } else {
                alertErrorMessage(result);
            };
        } catch (error) {
            alertErrorMessage(error);
        }
    };


    useEffect(() => {
        let timer;
        if (isOtpSent && countdown > 0) {
            timer = setInterval(() => {
                setCountdown((prevCountdown) => prevCountdown - 1);
            }, 1000);
        } else if (countdown === 0) {
            setIsOtpSent(false);
        }
        return () => clearInterval(timer);
    }, [isOtpSent, countdown]);

    return (

        <section class="section-padding login_sec">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-12 mx-auto">
                        <div class=" text-center  mb-4"><img src="assets/images/logo.svg" class="navbar-brand" alt="logo" /></div>
                        <form class="custom-form ticket-form mb-5 mb-lg-0 ">
                            <div className="login_form" >
                                <div class=" d-block text-center mb-5">
                                    <h2 class="mb-1">  <strong class=" "> Forgot Password? </strong> </h2>
                                    <p> Enter details to forgot your password.</p>
                                </div>
                                <div class=" cfield_group login_group">
                                    <label class="mb-2"> Email  </label>
                                    <div class="cfield mb-3">
                                        <input type="text" class="form-control" placeholder="Enter Email" name="emailId" value={formData.emailId.toLowerCase()}
                                            onChange={handleInputChange} onKeyDown={handleSpaces} />
                                    </div>
                                </div>
                                <div className="cfield_group login_group " >
                                    <label class="mb-2"> Verification Code  </label>
                                    <div class="cfield mb-3">
                                        <div class=" field-otp-box">
                                            <input type="text" class="form-control" placeholder="Enter Code" name="otp" value={formData.otp}
                                                onChange={handleInputChange}  />
                                            <button class="btn btn-sm btn-gradient" type="button" onClick={() => handleGetOtp('otp', formData.emailId.toLowerCase())} disabled={isOtpSent}>
                                                <span>{isOtpSent ? `Resend in ${countdown}s` : 'GET OTP'}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class=" cfield_group login_group">
                                    <label class="mb-2">  New Password </label>
                                    <div class="cfield mb-3 ">
                                        <div class=" field-otp-box">
                                            <input type={showPass ? 'text' : "password"} class="form-control" name="password" placeholder="Enter New Password" value={formData.password}
                                                onChange={handleInputChange} onKeyDown={handleSpaces} />
                                            <button type="button" class="btn btn-icon btn_view_pass btn-white" onClick={() => { setshowPass(!showPass) }}>
                                                <i className={`ri-eye${showPass ? "-line" : "-off-line"}`} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class=" cfield_group login_group">
                                    <label class="mb-2">  Confirm New Password </label>
                                    <div class="cfield mb-3 ">
                                        <div class=" field-otp-box">
                                            <input type={showPass2 ? 'text' : "password"} class="form-control" name="confirmPassword" placeholder="Enter Confirm New Password" value={formData.confirmPassword}
                                                onChange={handleInputChange} onKeyDown={handleSpaces} />
                                            <button type="button" class="btn btn-icon btn_view_pass btn-white" onClick={() => { setshowPass2(!showPass2) }}>
                                                <i className={`ri-eye${showPass2 ? "-line" : "-off-line"}`} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <button type="button" class="btn custom-btn btn-gradient btn-border w-100 mt-3" onClick={() => handleforgotPassword(formData.emailId, formData.otp, formData.password, formData.confirmPassword)}><span> SUBMIT</span></button>
                            </div>
                            <div className="col-12 text-center mt-2">
                                <p>Back to Login.? <Link className="fw-bold" to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Sign In</Link></p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ForgotPassword


